import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentItemHomePrimary } from "scmp-app/components/content/content-item-render/variants/home-primary";
import { ContentItemHomeSecondary } from "scmp-app/components/content/content-item-render/variants/home-secondary";
import { Summary } from "scmp-app/components/content/content-item-render/variants/home-secondary/styles";
import { HomeSponsorTagWrapper } from "scmp-app/components/sponsor-tag/styles";

export const StyledContentItemHomePrimary = styled(ContentItemHomePrimary)``;
export const StyledContentItemHomeSecondary = styled(ContentItemHomeSecondary)``;

export const Container = styled.div`
  ${HomeSponsorTagWrapper} {
    display: block;
  }

  ${Summary} {
    ${theme.breakpoints.only("mobile")} {
      display: none;
    }
  }
`;
